'use client';
import { Headline, Text } from '~components/Typography';
import { routes } from '~constants/routes';
import { NsfwReason, RegisterInbound } from '~features/annals';
import { useSession } from '~hooks/useSession';
import { useTranslations } from '~i18n/hooks';
import { ButtonGhost } from '~shared/ui/molecules';

import CloseIcon from '../../../../../public/assets/icons/close.svg';
import { useCanShowSafeModeSwitchingPopup } from '../../hooks/useSafeModeSwitchingPopup';
import { useSwitchSafeModeWithAgeValidation } from '../../hooks/useSwitchSafeMode';
import {
	CloseButton,
	Container,
	DescriptionContainer,
	NSFWExploreNoticeWrapper,
} from './styles';

export const NSFWExploreNotice = () => {
	const t = useTranslations('Grid');
	const { isSuccess, isSafeMode } = useSession();

	const { popupVisible, closePopup } = useCanShowSafeModeSwitchingPopup();
	const updateSafeMode = useSwitchSafeModeWithAgeValidation();

	const handleClick = () => {
		void updateSafeMode(false, {
			force: true,
			nsfwReason: NsfwReason.Grid,
			registerInbound: RegisterInbound.GridNsfwSearchSwitch,
		});
	};

	if (!popupVisible) {
		return null;
	}

	return (
		<NSFWExploreNoticeWrapper>
			<Container>
				<CloseButton leftIcon={<CloseIcon />} onClick={closePopup} />
				<DescriptionContainer>
					<Headline size="L" data-name="grid-nsfw-notice-title">
						{t('nsfwNoticeTitle')}
					</Headline>
					<Text align="left" size="M" data-name="grid-nsfw-notice-subtitle">
						{t('nsfwNoticeSubtitle')}
					</Text>
				</DescriptionContainer>
				{isSuccess && !isSafeMode ? (
					<ButtonGhost
						data-name="grid-nsfw-notice-button"
						href={routes.explore.models}
					>
						{t('nsfwNoticeButton')}
					</ButtonGhost>
				) : (
					<ButtonGhost
						data-name="grid-nsfw-notice-button"
						onClick={handleClick}
					>
						{t('nsfwNoticeButton')}
					</ButtonGhost>
				)}
			</Container>
		</NSFWExploreNoticeWrapper>
	);
};
